import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Form from '../Form';
import browserHistory from '../../../history';
import ApiService from '../../../services/ApiService';
import { modal } from '../../modal/ModalEmitter';
import toastr from '../../toastr';
import LoadingPage from '../../LoadingPage';
import FileNotFound from '../../FileNotFound';

const layout = [
  {
    name: 'reason',
    label: 'Reason',
    control: 'textarea',
    required: true,
  },
  {
    name: 'printer',
    label: 'Printer',
    options: [],
  },
];

const VoidRo = ({ roId }) => {
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  const submit = payload => {
    return ApiService.post(`/repair/${encodeURIComponent(roId)}/void`, payload).then(response => {
      const message = _.get(response, 'data.responses[0].message');
      if (/^https?:\/\//.test(message)) {
        window.open(message, '_blank');
      }
      toastr.success(`Voided ${roId}`, payload.reason);
    });
  };

  const submitCallback = () => {
    modal.close();

    // TODO should be smarter
    if (browserHistory.location.pathname !== '/SMM1') {
      browserHistory.goBack();
    }
  };

  const getPrinters = () => {
    const params = {
      repairOrderId: encodeURIComponent(roId),
      isOpen: true,
      purpose: 'void',
    };

    return ApiService.get('/printers/ro', { params }).then(response => {
      const { printers, error } = response.data;

      if (error) {
        setErrorMessage(error);
        return;
      }

      layout[1].options = printers;
    }).finally(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    if (errorMessage) {
      modal.close();
      modal.alert({ title: 'Notice', message: errorMessage });
    }
  }, [errorMessage]);

  useEffect(() => {
    if (!roId) {
      setErrorMessage('The given repair order number is invalid or not set yet');
      return;
    }

    getPrinters();
  }, []);

  if (loading) {
    return <LoadingPage style={{ height: '266px' }} />;
  }

  if (errorMessage) {
    return <FileNotFound>{errorMessage}</FileNotFound>;
  }

  return (
    <Form
      submitAll
      layout={layout}
      onCancel={() => modal.close()}
      submit={submit}
      submitCallback={submitCallback}
      exportFormat="object"
      feedback="none"
      trackDirty={false}
    />
  );
};

VoidRo.propTypes = {
  roId: PropTypes.string,
};

export default VoidRo;
